import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

export const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/system/Login.vue'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('@/layout/MainLayout.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/dashboard/Index.vue'), meta: { title: '数据看板' } },
      { path: 'users', name: 'UserList', component: () => import('@/views/user/List.vue'), meta: { title: '用户管理' } },
      { path: 'merchants', name: 'MerchantList', component: () => import('@/views/merchant/List.vue'), meta: { title: '商户管理' } },
      { path: 'merchant/customers', name: 'MerchantCustomer', component: () => import('@/views/merchant/Customer.vue'), meta: { title: '商户客户运营' } },
      { path: 'malls', name: 'MallList', component: () => import('@/views/mall/List.vue'), meta: { title: '商场管理' } },
      { path: 'mall/marketing', name: 'MallMarketing', component: () => import('@/views/mall/Marketing.vue'), meta: { title: '全域营销' } },
      { path: 'coupons', name: 'CouponList', component: () => import('@/views/coupon/List.vue'), meta: { title: '优惠券管理' } },
      { path: 'activities', name: 'ActivityList', component: () => import('@/views/activity/List.vue'), meta: { title: '活动管理' } },
      { path: 'activity/audit', name: 'ActivityAudit', component: () => import('@/views/activity/Audit.vue'), meta: { title: '活动审核' } },
      { path: 'reports', name: 'ReportList', component: () => import('@/views/data/Report.vue'), meta: { title: '数据报表' } },
      { path: 'system/config', name: 'SystemConfig', component: () => import('@/views/system/Config.vue'), meta: { title: '系统设置' } },
      { path: 'system/push', name: 'PushManage', component: () => import('@/views/system/Push.vue'), meta: { title: '消息推送' } },
      { path: 'premium', name: 'MerchantPremium', component: () => import('@/views/merchant/Premium.vue'), meta: { title: '商户增值服务' } },
      { path: 'product/list', name: 'ProductList', component: () => import('@/views/product/List.vue'), meta: { title: '商品审核' } },
      { path: 'product/category', name: 'ProductCategory', component: () => import('@/views/product/Category.vue'), meta: { title: '商品分类' } },
      { path: 'order/list', name: 'OrderList', component: () => import('@/views/order/List.vue'), meta: { title: '订单管理' } },
      { path: 'sessions', name: 'SessionList', component: () => import('@/views/session/List.vue'), meta: { title: '档期管理' } },
      { path: 'registration/audit', name: 'RegistrationAudit', component: () => import('@/views/registration/Audit.vue'), meta: { title: '报名审核' } },
      { path: 'booths', name: 'BoothList', component: () => import('@/views/booth/List.vue'), meta: { title: '摊位管理' } },
      { path: 'booth/floor-plan', name: 'BoothFloorPlan', component: () => import('@/views/booth/FloorPlan.vue'), meta: { title: '摊位平面图' } },
      { path: 'qualification/audit', name: 'QualificationAudit', component: () => import('@/views/qualification/Audit.vue'), meta: { title: '资质审核' } },
      { path: 'finance/batches', name: 'FinanceBatches', component: () => import('@/views/finance/Batches.vue'), meta: { title: '结算批次' } },
      { path: 'finance/flows', name: 'FinanceFlows', component: () => import('@/views/finance/Flows.vue'), meta: { title: '资金流水' } },
      { path: 'finance/config', name: 'FinanceConfig', component: () => import('@/views/finance/Config.vue'), meta: { title: '分账配置' } },
      { path: 'fans', name: 'FanList', component: () => import('@/views/fan/List.vue'), meta: { title: '粉丝管理' } },
      { path: 'reconcile', name: 'ReconcileIndex', component: () => import('@/views/reconcile/Index.vue'), meta: { title: '对账中心' } },
      { path: 'reconcile/logs', name: 'OperationLogs', component: () => import('@/views/reconcile/Logs.vue'), meta: { title: '操作日志' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 路由守卫：未登录跳转登录页
const whiteList = ['/login']
router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) !== -1) {
    return next()
  }
  const token = getToken()
  if (!token) {
    return next('/login')
  }
  next()
})

export default router
